// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwFlexColumn from 'viewmodel/AwFlexColumnViewModel';
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwSearchBox from 'viewmodel/AwSearchBoxViewModel';
import AwList from 'viewmodel/AwListViewModel';
import AwDefaultCell from 'viewmodel/AwDefaultCellViewModel';
import AwIcon from 'viewmodel/AwIconViewModel';
import AwLink from 'viewmodel/AwLinkViewModel';
import AwNavigateBreadcrumb from 'viewmodel/AwNavigateBreadcrumbViewModel';
import AwScrollpanel from 'viewmodel/AwScrollpanelViewModel';
    import { VisibleWhen } from 'js/hocCollection';
const AwFlexColumnVisibleWhen = VisibleWhen(AwFlexColumn);
AwFlexColumnVisibleWhen.displayName = 'AwFlexColumnVisibleWhen';

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/desNavigateContentAsListDefaultService', () => import('js/desNavigateContentAsListDefaultService'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "lifecycleHooks": {
        "onMount": "",
        "onUpdate": [
            {
                "action": "init",
                "observers": [
                    "props.accsessionid",
                    "props.collaborationspaceid"
                ]
            }
        ]
    },
    "data": {
        "searchBox": {
            "displayName": "",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "true",
            "dbValue": null,
            "dispValue": ""
        },
        "searchBoxPlaceHolder": {
            "dbValue": "{{i18n.searchBoxplaceholder}}"
        },
        "selectedLibraryId": {
            "displayName": "",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "true",
            "dbValue": null,
            "dispValue": ""
        },
        "selectedFolderId": {
            "displayName": "",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "true",
            "dbValue": null,
            "dispValue": ""
        },
        "skip": 0,
        "allContentLink": {
            "displayName": "{{i18n.allContentLink}}",
            "type": "STRING",
            "isRequired": "false"
        },
        "dynamicCrumbs": [],
        "bcConfig": {
            "navigationBreadcrumbConfig": {
                "type": "navigate",
                "vm": "navigateBreadcrumblist",
                "chevronDataProvider": "navigationBreadcrumbchevronDataProvider",
                "id": "d_uids",
                "noUpdate": true,
                "displayProperty": "object_string"
            }
        }
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "collaborationspaceid": {
            "type": "string"
        },
        "containerid": {
            "type": "string"
        },
        "containertype": {
            "type": "string"
        },
        "folderid": {
            "type": "string"
        },
        "showfoldersonly": {
            "type": "boolean"
        }
    },
    "actions": {
        "init": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "refreshViewModel"
                },
                {
                    "action": "getContainersDataProvider"
                }
            ]
        },
        "refreshViewModel": {
            "actionType": "JSFunction",
            "method": "refreshViewModel",
            "inputData": {
                "data": "{{data}}"
            },
            "deps": "js/desNavigateContentAsListDefaultService"
        },
        "getContainersDataProvider": {
            "actionType": "dataProvider",
            "method": "getContainersDataProvider"
        },
        "resetSkipAndGetContainersDataProvider": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "resetSkipVals"
                },
                {
                    "action": "getContainersDataProvider"
                }
            ]
        },
        "resetSkipVals": {
            "actionType": "JSFunction",
            "method": "resetSkipVals",
            "inputData": {
                "data": "{{data}}"
            },
            "deps": "js/desNavigateContentAsListDefaultService"
        },
        "manageListCellSelection": {
            "actionType": "JSFunction",
            "method": "manageListCellSelection",
            "inputData": {
                "data": "{{data}}",
                "selectedObjects": "{{data.eventData.selectedObjects}}"
            },
            "deps": "js/desNavigateContentAsListDefaultService",
            "events": {
                "success": [
                    {
                        "condition": "(data.eventData.selectedObjects[0].containerType === 'library' || data.eventData.selectedObjects[0].containerType === 'project' || data.eventData.selectedObjects[0].containerType === 'Folder')",
                        "name": "NavigateContentsAsList.resetAndloadContents"
                    },
                    {
                        "condition": "data.eventData.selectedObjects.length !== 0 && (data.eventData.selectedObjects[0].containerType === 'library' || data.eventData.selectedObjects[0].containerType === 'Folder')",
                        "name": "NavigateContentsAsList.projectOrFolderSelected",
                        "eventData": {
                            "projectOrFolderSelected": "{{data.eventData.selectedObjects[0]}}"
                        }
                    },
                    {
                        "condition": "data.eventData.selectedObjects.length === 0 || (data.eventData.selectedObjects[0].containerType !== 'Project' && data.eventData.selectedObjects[0].containerType !== 'Folder')",
                        "name": "NavigateProjectContentsAsList.partSelected",
                        "eventData": {
                            "selectedObjects": "{{data.eventData.selectedObjects}}"
                        }
                    }
                ]
            }
        },
        "manageCrumbSelection": {
            "actionType": "JSFunction",
            "method": "manageCrumbSelection",
            "inputData": {
                "data": "{{data}}",
                "crumbIndex": "{{data.eventData.crumbIndex}}"
            },
            "deps": "js/desNavigateContentAsListDefaultService",
            "events": {
                "success": [
                    {
                        "name": "NavigateContentsAsList.resetAndloadContents"
                    }
                ]
            }
        },
        "resetSkipAndManageCrumbSelection": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "resetSkipVals"
                },
                {
                    "action": "manageCrumbSelection"
                }
            ]
        },
        "getContainers": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationSpaceId": "{{props.collaborationspaceid}}"
                        },
                        "query": "query listContent( $listInput: ListInput ) { listContent( listInput: $listInput) }",
                        "variables": {
                            "listInput": {
                                "containerType": "{{props.containertype}}",
                                "containerId": "{{props.containerid || data.selectedLibraryId.dbValue}}",
                                "folderId": "{{data.selectedFolderId.dbValue || props.folderid }}",
                                "filterType": "{{props.showfoldersonly}}",
                                "searchInput": "{{data.searchBox.dbValue}}",
                                "searchOptions": {
                                    "limit": 20,
                                    "skip": 0,
                                    "outputProperties": [
                                        "*"
                                    ]
                                }
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}",
                "loadBydefault": true
            },
            "outputData": {
                "totalFound": "data.data.listContent.totalCount",
                "librariesFound": "data.data.listContent.filterObj"
            },
            "events": {
                "success": [
                    {
                        "name": "usePartSuccess",
                        "eventData": {
                            "eventName": "usePartSuccess",
                            "eventData": "{{librariesFound}}"
                        }
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        }
    },
    "conditions": {
        "isBreadCrumbEnabled": {
            "expression": "(data.selectedLibraryId.dbValue || data.selectedFolderId.dbValue) !== null"
        }
    },
    "dataProviders": {
        "getContainersDataProvider": {
            "action": "getContainers",
            "response": "{{data.librariesFound}}",
            "totalFound": "{{data.totalFound}}",
            "selectionModelMode": "single",
            "inputData": {
                "selectionModel": "{{subPanelContext.selectionModel}}"
            },
            "commandsAnchor": "search_cell_commands"
        }
    },
    "onEvent": [
        {
            "eventId": "getContainersDataProvider.selectionChangeEvent",
            "cacheEventData": true,
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "listLibrariesSelectionChange",
                "eventData": "{{eventData.selectedObjects}}"
            }
        },
        {
            "eventId": "NavigateContentsAsList.breadCrumbSelected",
            "action": "resetSkipAndManageCrumbSelection",
            "cacheEventData": true
        },
        {
            "eventId": "NavigateContentsAsList.breadCrumbSelected",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventId": "des-navigate-contents-as-list.partSelected",
                "eventData": "{{eventData.crumb}}"
            }
        },
        {
            "eventId": "NavigateContentsAsList.breadCrumbSelected",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventId": "des-navigate-contents-as-list.part-selected",
                "eventData": "{{eventData.crumb}}"
            }
        },
        {
            "eventId": "NavigateContentsAsList.projectOrFolderSelected",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventId": "des-navigate-contents-as-list.partSelected",
                "eventData": "{{eventData.projectOrFolderSelected}}"
            }
        },
        {
            "eventId": "NavigateContentsAsList.projectOrFolderSelected",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventId": "des-navigate-project-contents-as-list.part-selected",
                "eventData": "{{eventData.projectOrFolderSelected}}"
            }
        },
        {
            "eventId": "NavigateProjectContentsAsList.partSelected",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventId": "des-navigate-project-contents-as-list.partSelected",
                "eventData": "{{eventData.selectedObjects}}"
            }
        },
        {
            "eventId": "NavigateProjectContentsAsList.partSelected",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventId": "des-navigate-project-contents-as-list.part-selected",
                "eventData": "{{eventData.selectedObjects}}"
            }
        },
        {
            "eventId": "NavigateContentsAsList.resetAndloadContents",
            "action": "resetSkipAndGetContainersDataProvider"
        },
        {
            "eventId": "openLibraryAndNavigateToContent",
            "action": "manageListCellSelection",
            "inputArgs": {
                "eventId": "des-search-results-as-list-item.open",
                "eventData": "{{eventData.selectedObject}}"
            }
        }
    ],
    "i18n": {
        "content": [
            "libraryMessages"
        ],
        "searchBoxplaceholder": [
            "libraryMessages"
        ],
        "allContentLink": [
            "libraryMessages"
        ]
    },
    "_viewModelId": "DesNavigateContentAsList",
    "_uniqueViewModelId": "DesNavigateContentAsList",
    "ctx": {}
};

    /*
    <div class="afx-content-background aw-layout-full">
    <aw-flex-column width="fill" visible-when="!conditions.isBreadCrumbEnabled" class="aw-layout-full">
        <aw-flex-row height="4f" class="aw-widgets-cellListCellTitleBlock">
            <span class="aw-widgets-cellListCellTitle">{{i18n.content}}</span>
        </aw-flex-row>
        <aw-flex-row height="3.5f">
            <aw-flex-column width="fill">
                <aw-search-box prop="data.searchBox" placeholder="data.searchBoxPlaceHolder.dbValue" action="resetSkipAndGetContainersDataProvider"></aw-search-box>
            </aw-flex-column>
        </aw-flex-row>
        <aw-list dataprovider="data.dataProviders.getContainersDataProvider" hasFloatingCellCommands="false">
            <cell>
            <aw-default-cell vmo="item"></aw-default-cell>
        </cell>
        </aw-list>
    </aw-flex-column>
    <aw-flex-column width="fill" visible-when="conditions.isBreadCrumbEnabled" class="aw-layout-full">
        <aw-flex-row height="1.5f">
            <aw-flex-column width="1f" class="aw-layout-fxbreadCrumbs">
                <aw-icon icon-id="miscChevronLeftDouble" class="sw-button-icon"></aw-icon>
            </aw-flex-column>
            <aw-link action="init" prop="data.allContentLink"></aw-link>
        </aw-flex-row>
        <aw-flex-row height="3.5f">
            <aw-navigate-breadcrumb crumbs="data.dynamicCrumbs" breadcrumb-config ="data.bcConfig.navigationBreadcrumbConfig" popupList="NavigateBreadcrumblist"></aw-navigate-breadcrumb>
        </aw-flex-row>
        <aw-flex-row height="3.5f">
            <aw-flex-column width="fill">
                <aw-search-box prop="searchBox" placeholder="data.searchBoxPlaceHolder.dbValue"
                    action="resetSkipAndGetContainersDataProvider"></aw-search-box>
            </aw-flex-column>
        </aw-flex-row>
        <aw-flex-row>
            <aw-scrollpanel>
                <aw-list dataprovider="data.dataProviders.getContainersDataProvider">
                    <cell>
                        <aw-default-cell vmo="item"></aw-default-cell>
                    </cell>
                </aw-list>
            </aw-scrollpanel>
        </aw-flex-row>
    </aw-flex-column>
    </div>

    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <div className="afx-content-background aw-layout-full">
        <AwFlexColumnVisibleWhen width="fill" className="aw-layout-full" visibleWhen={AwParseService.instance( "!conditions.isBreadCrumbEnabled" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
            <AwFlexRow height="4f" className="aw-widgets-cellListCellTitleBlock">
                <span className="aw-widgets-cellListCellTitle">
                    {AwParseService.instance( "i18n.content" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
                </span>
            </AwFlexRow>
            <AwFlexRow height="3.5f">
                <AwFlexColumn width="fill">
                    <AwSearchBox {...getField("data.searchBox", fields, $index, null, null )} placeholder={AwParseService.instance( "data.searchBoxPlaceHolder.dbValue" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} action={actions.resetSkipAndGetContainersDataProvider}>
                    </AwSearchBox>
                </AwFlexColumn>
            </AwFlexRow>
            <AwList dataprovider={dataProviders.getContainersDataProvider} showDropArea={null} dndHandler={props.viewModel.dndHandler} hasfloatingcellcommands="false">{({item, index})=>{ return <>                <cell>
                    <AwDefaultCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
                    </AwDefaultCell>
                </cell></> } }
            </AwList>
        </AwFlexColumnVisibleWhen>
        <AwFlexColumnVisibleWhen width="fill" className="aw-layout-full" visibleWhen={AwParseService.instance( "conditions.isBreadCrumbEnabled" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
            <AwFlexRow height="1.5f">
                <AwFlexColumn width="1f" className="aw-layout-fxbreadCrumbs">
                    <AwIcon iconId="miscChevronLeftDouble" className="sw-button-icon">
                    </AwIcon>
                </AwFlexColumn>
                <AwLink action={actions.init} {...getField("data.allContentLink", fields, $index, null, null )}>
                </AwLink>
            </AwFlexRow>
            <AwFlexRow height="3.5f">
                <AwNavigateBreadcrumb crumbs={AwParseService.instance( "data.dynamicCrumbs" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} breadcrumb-config="data.bcConfig.navigationBreadcrumbConfig" popuplist="NavigateBreadcrumblist">
                </AwNavigateBreadcrumb>
            </AwFlexRow>
            <AwFlexRow height="3.5f">
                <AwFlexColumn width="fill">
                    <AwSearchBox {...getField("searchBox", fields, $index, null, null )} placeholder={AwParseService.instance( "data.searchBoxPlaceHolder.dbValue" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} action={actions.resetSkipAndGetContainersDataProvider}>
                    </AwSearchBox>
                </AwFlexColumn>
            </AwFlexRow>
            <AwFlexRow>
                <AwScrollpanel>
                    <AwList dataprovider={dataProviders.getContainersDataProvider} showDropArea={null} dndHandler={props.viewModel.dndHandler}>{({item, index})=>{ return <>                        <cell>
                            <AwDefaultCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
                            </AwDefaultCell>
                        </cell></> } }
                    </AwList>
                </AwScrollpanel>
            </AwFlexRow>
        </AwFlexColumnVisibleWhen>
    </div>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;